import { SETUP_ORG_FOR_FEATURE } from "../../constants/Urls";
import OrgSetupRequest from "../../models/orgSetup/OrgSetupRequest";
import OrgSetupResponse from "../../models/orgSetup/OrgSetupResponse";
import IResult from "../../models/result/IResult";
import { sendPost } from "./generic";

export const setupOrgForFeature = (orgSetupRequest: OrgSetupRequest): Promise<IResult<OrgSetupResponse>> => {
    return sendPost(SETUP_ORG_FOR_FEATURE, orgSetupRequest);
};